// 网站相关全部请求
import environment from '../../config/environment'
export const cw1 = environment.cw1Url
export const api5 = environment.api5Url
export const api3 = environment.api3Url
export const pcapi = environment.pcUrl
import {getWebsiteListAPI, getWebDetailAPI, getGxCodeAPI, fetch} from '../api'
import {encrypt} from '../common'
import qs from 'qs'

// 常量
const API_CODE = environment.apiCode
const API_KEY = environment.apiKey

// 网站列表查询
function getWebsiteList (paramObj, token) {
    // json转string
    const paramStr = JSON.stringify(paramObj)
    // 变密
    const params = qs.stringify({
        code: API_CODE,
        token: token,
        param: encrypt(paramStr, API_CODE, API_KEY)
    })
    return getWebsiteListAPI(params)
}

// 网站详情查询
function getWebDetail (paramObj, token) {
    // json转string
    const paramStr = JSON.stringify(paramObj)
    // 变密
    const params = qs.stringify({
        code: API_CODE,
        token: token,
        param: encrypt(paramStr, API_CODE, API_KEY)
    })
    return getWebDetailAPI(params)
}

// 获取公信码详情
function getGxCode(paramObj, token) {
    // json转string
    const paramStr = JSON.stringify(paramObj);
    // 变密
    const params = qs.stringify({
        code: API_CODE,
        token: token,
        param: encrypt(paramStr, API_CODE, API_KEY)
    });
    return getGxCodeAPI(params);
}


// 保存记录
function saveRecentBrowser (paramObj, token) {
    const paramStr = JSON.stringify(paramObj)
    const params = qs.stringify({
        code: API_CODE,
        token: token,
        param: encrypt(paramStr, API_CODE, API_KEY)
    })
    return fetch(params, `${api3}/companyBrowseRecord/saveRecentBrowse`)
}

export {getWebsiteList, getWebDetail, getGxCode, saveRecentBrowser}



// WEBPACK FOOTER //
// ./src/request/index/website.js